<template>
  <div id="qrcode-dialog">
    <div class="title">VIP会员专享</div>
    <div class="sub">
      领取直播电商内参资料
      <br>
      请联系壁虎看看首席服务官
    </div>
    <img src="https://s6.bihukankan.com/bihu_wx_code/1126candy.png" alt="qrcode" class="qrcode">
    <div class="tips">可复制微信号后去添加好友</div>
    <div class="id">微信号：bihu946</div>
    <div id="copy-btn" data-clipboard-text="bihu946" @click="copy" style="color: #2a89f4">点击复制</div>
  </div>
</template>

<script>
export default {
  methods: {
    copy() {
      const clipboard = new ClipboardJS('#copy-btn');
      clipboard.on('success', e => {
        e.clearSelection();
      });
      this.$dialog.alert({
        message: '复制成功，去微信首页添加好友'
      })
    }
  }
}
</script>

<style lang="less" scoped>
#qrcode-dialog {
  height: 8rem;
  background: #ffffff;
  box-shadow: 0 0.02rem 0.2rem 0 rgba(161, 174, 191, 0.3);
  border-radius: 0.08rem;
  text-align: center;
  padding-top: .6rem;

  .title {
    font-size: 0.42rem;
    font-weight: 600;
    color: #ff5000;
  }

  .sub {
    font-size: 0.28rem;
    font-weight: 400;
    color: #ff5000;
    line-height: 0.42rem;
    margin: .3rem 0 .7rem;
  }

  .qrcode {
    width: 2.8rem;
    height: 2.8rem;
  }

  .tips {
    margin: .3rem 0;
    font-size: 0.28rem;
    font-weight: 400;
    color: #4a4a4a;
  }

  .id {
    font-size: 0.28rem;
    font-weight: 400;
    color: #a1aebf;
    margin-bottom: .6rem;
  }
}
</style>